import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=64852318&scoped=true"
import script from "./WorkingHours.vue?vue&type=script&lang=js"
export * from "./WorkingHours.vue?vue&type=script&lang=js"
import style0 from "./WorkingHours.vue?vue&type=style&index=0&id=64852318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64852318",
  null
  
)

export default component.exports